module.exports = __webpack_public_path__ + "img/icon-asset-charger.912b0d1a.png";